import { ElementType, ReactNode } from 'react';
import { RiCheckLine, RiCloseLine } from 'react-icons/ri';
import {
  Box,
  Icon,
  SegmentGroup,
  SegmentGroupValueChangeDetails,
} from '@chakra-ui/react';

import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';
import { FormLabel } from './FormLabel.component';

// @TODO Handle onBlur somehow?

type ToggleProps = {
  content: ReactNode;
};

type ToggleItem = {
  value: string;
  label: string;
  icon: ElementType;
};

// The segments are icon only, so each `label` exists for assistive technology
// alone and the icon is hidden from it.
const toggleItems: ToggleItem[] = [
  {
    value: 'true',
    label: 'Yes',
    icon: RiCheckLine,
  },
  {
    value: 'false',
    label: 'No',
    icon: RiCloseLine,
  },
];

export const Toggle: FormFieldControlledComponent<
  string | undefined,
  ToggleProps
> = ({
  content,
  onChange,
  value,
  name,
  invalid,
  disabled,
  readOnly,
  required,
}: FormFieldControlledComponentProps<string | undefined, ToggleProps>) => {
  const toggleValue = (nextValue: SegmentGroupValueChangeDetails): void =>
    onChange(nextValue.value !== value ? nextValue.value : undefined);

  // FormField renders no label for a toggle block, so this is the group's only
  // label.
  const labelId = `${name}-label`;

  return (
    <Box display="flex" justifyContent="space-between" w="full">
      <FormLabel id={labelId} readOnly={readOnly} required={required}>
        {content}
      </FormLabel>

      <SegmentGroup.Root
        aria-labelledby={labelId}
        disabled={disabled}
        name={name}
        onValueChange={toggleValue}
        value={value}
        variant="toggle"
      >
        {/* <SegmentGroup.Indicator /> */}
        {toggleItems.map((item) => (
          <SegmentGroup.Item
            key={item.value}
            invalid={invalid}
            value={item.value}
          >
            <SegmentGroup.ItemText>
              <Icon aria-hidden as={item.icon} boxSize={6} />
            </SegmentGroup.ItemText>
            <SegmentGroup.ItemHiddenInput aria-label={item.label} />
          </SegmentGroup.Item>
        ))}
      </SegmentGroup.Root>
    </Box>
  );
};

Toggle.controlled = true;
Toggle.displayName = 'Toggle';
